import React, { useState } from 'react';

/**
 * CalendarioEmbedido - Componente wrapper para pruebas
 * Permite ingresar el token de calendario manualmente para testing
 * 
 * En producción, el cliente pasará el token como prop:
 * <CalendarioEmbedido token="abc123..." />
 */
export default function CalendarioEmbedido({ token: propToken }) {
  const [token, setToken] = useState(propToken || '');
  const [mostrarIframe, setMostrarIframe] = useState(!!propToken);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (token.trim()) {
      setMostrarIframe(true);
    }
  };

  const handleCambiarClinica = () => {
    setMostrarIframe(false);
    setToken('');
  };

  // Si ya viene el token por props, mostrar directamente el iframe
  if (propToken) {
    const baseUrl = window.location.origin;
    const iframeUrl = `${baseUrl}/calendario-publico/${propToken}`;

    return (
      <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
        <iframe
          src={iframeUrl}
          title="Sistema de Citas"
          style={{
            flex: 1,
            border: 'none',
            width: '100%'
          }}
          allow="fullscreen"
        />
      </div>
    );
  }

  // Modo pruebas - mostrar formulario
  if (!mostrarIframe) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #3cbf9a 0%, #2ea885 100%)',
        padding: '20px'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
          maxWidth: '450px',
          width: '100%',
          padding: '40px'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'linear-gradient(135deg, #3cbf9a 0%, #2ea885 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              fontSize: '40px'
            }}>
              🏥
            </div>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', marginBottom: '8px' }}>
              Sistema de Citas
            </h2>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              Modo Pruebas - Ingrese el token de calendario
            </p>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '600', 
                color: '#374151', 
                marginBottom: '8px' 
              }}>
                Token de Calendario *
              </label>
              <input
                type="text"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Ej: a1b2c3d4e5f6..."
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e5e7eb',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'monospace',
                  transition: 'border-color 0.2s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3cbf9a'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
              <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '6px' }}>
                Ingrese el token de calendario público de la clínica
              </p>
            </div>

            <div style={{
              background: '#eff6ff',
              border: '1px solid #bfdbfe',
              borderRadius: '8px',
              padding: '12px',
              fontSize: '12px',
              color: '#1e40af'
            }}>
              <div style={{ fontWeight: '600', marginBottom: '4px' }}>ℹ️ ¿Dónde obtener el token?</div>
              <div>
                El administrador de la clínica puede generar el token desde el panel de gestión de clientes,
                en la opción "Gestionar Token de Calendario".
              </div>
            </div>

            <button
              type="submit"
              style={{
                padding: '14px 24px',
                background: 'linear-gradient(135deg, #3cbf9a 0%, #2ea885 100%)',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              Acceder al Calendario
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Mostrar iframe con botón para cambiar clínica
  const baseUrl = window.location.origin;
  const iframeUrl = `${baseUrl}/calendario-publico/${token}`;

  return (
    <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
      {/* Barra superior con botón de cambiar clínica */}
      <div style={{
        background: 'white',
        borderBottom: '1px solid #e5e7eb',
        padding: '12px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px'
      }}>
        <div style={{ fontSize: '14px', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ 
            background: '#fef3c7', 
            color: '#92400e', 
            padding: '4px 8px', 
            borderRadius: '4px', 
            fontSize: '12px',
            fontWeight: '600'
          }}>
            MODO PRUEBAS
          </span>
          <span style={{ fontFamily: 'monospace', fontSize: '12px' }}>
            Token: {token.substring(0, 8)}...
          </span>
        </div>
        <button
          onClick={handleCambiarClinica}
          style={{
            padding: '8px 16px',
            background: '#f3f4f6',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            color: '#374151',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.background = '#e5e7eb'}
          onMouseLeave={(e) => e.target.style.background = '#f3f4f6'}
        >
          Cambiar Token
        </button>
      </div>

      {/* Iframe */}
      <iframe
        src={iframeUrl}
        title="Sistema de Citas"
        style={{
          flex: 1,
          border: 'none',
          width: '100%'
        }}
        allow="fullscreen"
      />
    </div>
  );
}